import * as React from "react";
import VingleDialog, { VingleDialogTypes } from "../../../vingleDialog";
import { BasicDialogTypes } from "app/vingleDialog/components/basic";
import ImageHolder from "common/components/imageHolder";
import { injectIntl, WrappedComponentProps } from "react-intl";
// styles

const styles = require("./mobileDialog.scss");

interface IProps extends WrappedComponentProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const MobileAppDownloadDialog = ({ isOpen, intl, onRequestClose }: IProps) => {
  return (
    <VingleDialog
      type={VingleDialogTypes.BASIC}
      open={isOpen}
      basicContentType={BasicDialogTypes.BASIC}
      onRequestClose={onRequestClose}
      omitWholeButtons={true}
    >
      <div className={styles.mobileDownloadContainer}>
        <h1 className={styles.mobileDownloadTitle}>
          {intl.formatMessage({ id: "signup.mobile_app_donwload_title" })}
        </h1>
        <a
          target="_blank"
          href="https://www.google.com/url?q=https%3A%2F%2Fitunes.apple.com%2Fkr%2Fapp%2Fvingle-%25EB%25B9%2599%25EA%25B8%2580%2Fid637534820%3Fmt%3D8&sa=D&sntz=1&usg=AFQjCNGsbqhE7qUy0kZ-g1p37PiJtQQtOw"
          className={styles.imageWrapper}
        >
          <ImageHolder src="https://s0.vingle.net/images/btn-popup-appstore.jpg" />
        </a>
        <a
          target="_blank"
          href="https://play.google.com/store/apps/details?id=com.vingle.android"
          className={styles.imageWrapper}
        >
          <ImageHolder src="https://s0.vingle.net/images/btn-popup-playstore.jpg" />
        </a>
      </div>
    </VingleDialog>
  );
};

export default injectIntl(MobileAppDownloadDialog);
